export const stripHtml = (html: string) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const textContent = doc.documentElement.textContent ?? "";
  const text = `${textContent.split(" [")[0]}...`;
  return text;
};
